const routes = [
    {
        path: '/jftech/news/list',
        component: function () {
            return import('@/components/admin/jftech/NewsList')
        }
    },
    {
        path: '/jftech/news/detail',
        component: function () {
            return import('@/components/admin/jftech/NewsDetail')
        }
    },
    {
        path: '/jftech/ad/manager',
        component: function () {
            return import('@/components/admin/jftech/Ad')
        }
    },
    // {
    //     path: '/cap/category/list',
    //     component: function () {
    //         return import('@/components/admin/cap/NewsCategory')
    //     }
    // },
    // {
    //     path: '/cap/category/detail',
    //     component: function () {
    //         return import('@/components/admin/cap/NewsCategoryDetail')
    //     }
    // },
    // {
    //     path: '/cap/contact',
    //     component: function () {
    //         return import('@/components/admin/cap/ContactList')
    //     }
    // },
]

export default routes